import { GiphyFetch } from '@giphy/js-fetch-api';

export const gf = new GiphyFetch(process.env.REACT_APP_GIPHY_API_KEY as string);
